import { Component, OnInit } from '@angular/core';
import * as momnet from 'moment'
import { FormControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  textBox=new FormControl();
  links:any;
  loading:boolean;
  constructor(private http: HttpClient) { }

  ngOnInit() {
  }

  onScrapper(){
    this.loading=true;
    this.http.post(
      'https://us-central1-auxswot-spel.cloudfunctions.net/scraper',
      JSON.stringify({ text: this.textBox.value })
    )
    .subscribe(res => {
      this.links = res;
      this.loading=false;
    });
  }

  onXReadingScrapper(){
    this.loading=true;
    this.http.post(
      'https://us-central1-auxswot-spel.cloudfunctions.net/xReadingScraper',
      JSON.stringify({ text: 'buth.sitha' })
    )
    .subscribe(res => {
      this.links = res;
      this.loading=false;
    });
  }

  today(date: Date) {
    const fromDate = momnet(date).startOf('day');
    const toDate = momnet(date).endOf('day');
    return ({ fromDate, toDate });
  }

  yesterday(date: Date) {
    const fromDate = momnet(date).startOf('day').subtract(1, 'day');
    const toDate = momnet(date).endOf('day').subtract(1, 'day');
    return ({ fromDate, toDate });
  }

  thisWeek(date: Date) {
    const fromDate = momnet(date).startOf('week');
    const toDate = momnet(date).endOf('week');
    return ({ fromDate, toDate });
  }

  lastWeek(date: Date) {
    const fromDate = momnet(date).startOf('week').subtract(1, 'week');
    const toDate = momnet(date).endOf('week').subtract(1, 'week');
    return ({ fromDate, toDate });
  }

  thisMonth(date: Date) {
    const fromDate = momnet(date).startOf('month');
    const toDate = momnet(date).endOf('month');
    return ({ fromDate, toDate });
  }

  lastMonth(date: Date) {
    const fromDate = momnet(date).startOf('month').subtract(1, 'month');
    const toDate = momnet(date).endOf('month').subtract(1, 'month');
    return ({ fromDate, toDate });
  }

  lastThreeMonth(date: Date) {
    const fromDate = momnet(date).startOf('month').subtract(3, 'month');
    const toDate = momnet(date).endOf('month').subtract(3, 'month');
    return ({ fromDate, toDate });
  }

  lastSixMonth(date: Date) {
    const fromDate = momnet(date).startOf('month').subtract(6, 'month');
    const toDate = momnet(date).endOf('month').subtract(6, 'month');
    return ({ fromDate, toDate });
  }

  thisYear(date: Date) {
    const fromDate = momnet(date).startOf('year');
    const toDate = momnet(date).endOf('year');
    return ({ fromDate, toDate });
  }

  lastYear(date: Date) {
    const fromDate = momnet(date).startOf('year').subtract(1, 'year');
    const toDate = momnet(date).endOf('year').subtract(1, 'year');
    return ({ fromDate, toDate });
  }

}
